export enum CommunicationsResponseCreateAsyncServiceRequestError {
  invalidPhone = 'invalidPhone',
}
